import { render, staticRenderFns } from "./ModifierReportingDispenses.vue?vue&type=template&id=5b7da48d&"
import script from "./ModifierReportingDispenses.vue?vue&type=script&lang=js&"
export * from "./ModifierReportingDispenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports